var exports = {
  "hS": "ForwardModal.module__richInput___Nkl6SV",
  "NG": "ForwardModal.module__footerSection___Nkl6SV",
  "vm": "ForwardModal.module__messageInputContainer___Nkl6SV",
  "hj": "ForwardModal.module__messageInputContainerDisabled___Nkl6SV",
  "zt": "ForwardModal.module__messageInputContainerWithCounter___Nkl6SV",
  "pn": "ForwardModal.module__messageInputContainerWithNotice___Nkl6SV",
  "XK": "ForwardModal.module__slowmodeNotice___Nkl6SV",
  "X8": "ForwardModal.module__messageInputActions___Nkl6SV",
  "Vr": "ForwardModal.module__emojiPickerButton___Nkl6SV",
  "Z8": "ForwardModal.module__emojiPickerButtonActive___Nkl6SV",
  "mI": "ForwardModal.module__emojiIcon___Nkl6SV",
};

module.exports = exports;
